var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-background text-contrast",attrs:{"id":"app"}},[_c('NavBar'),_c('router-view',{staticClass:"views-padding"}),_c('AppFooter',{attrs:{"id":"footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }